// import {EventBus} from '/src/main'

export const scrollBehavior = (to, from, savedPosition) => {
  // console.log('sb from', from)
  // console.log('sb to', to)
  // console.log('sb sp', savedPosition)
  // если переход происходит на самом деле в рамках одной странице, то произойдёт скролл плагином
  // но на самом деле, если человек сделает переход на якорь без обновления страницы (через адресную строку), то тоже произойдёт этот случай
  // и прокрутка произойдёт неправильно, но на это в принципе можно забить
  // if (to.name === from.name && !to.params.allowScrollToHash) {
  //   return
  // }
  // если есть якорь, но переход с другой страницы, надо руками сделать выбор ординаты, как в плагине
  if (to.hash) {
    // тут почему-то был промис с шиной. пока закомментил, надо разобраться втф
    // return new Promise((resolve, reject) => {
    //   EventBus.$on('scroll.stuff.loaded', () => {
    //     let offset = 0
    //     let navbar = document.getElementById('navbar')
    //     if (navbar) {
    //       offset = navbar.offsetHeight
    //     }
    //     resolve({ selector: to.hash, offset: { x: 0, y: offset } })
    //   })
    // })
    let offset = 0
    let navbar = document.getElementById('navbar')
    if (navbar) {
      offset = navbar.offsetHeight
    }
    return { selector: to.hash, offset: { x: 0, y: offset } }
    // return { selector: to.hash, offset: { x: 0, y: offset } }
  }
  if (savedPosition) {
    return savedPosition
  }
  return { x: 0, y: 0 }

  // // TODO: Leha `from` is an Object do something with this
  // // this function should return object with coordinates not router`s object
  // // console.warn('Scroll behavior', from, to.name)
  // let allowed = ['GetMenuPlan', 'MobileGetMenuPlan', 'TargetDetails', 'WeekMenu', 'CreateNewOrder', 'TryCustomization']
  // return { x: 0, y: allowed.includes(to.name) ? 0 : from }
}



// WEBPACK FOOTER //
// ./src/router/functions/scrollBehavior.js